import { render, staticRenderFns } from "./listTable.vue?vue&type=template&id=54c7aba3"
import script from "./listTable.vue?vue&type=script&lang=js"
export * from "./listTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports